import {put, takeEvery, call} from 'redux-saga/effects';
import {
    OPEN_PERIOD_ACTION_REQUEST,
    OPEN_PERIOD_ACTION_SUCCESS,
    OPEN_PERIOD_ACTION_FAILURE,
    OPEN_PERIOD_ACTION
} from '../constants';

import Api, {ApiMethods} from 'feedback-system/middleware/api';

import {
    OpenPeriodRequest,
    OpenPeriodSuccess,
    OpenPeriodFailure,
    OpenPeriodAction
} from '../typedef';

type IActions = OpenPeriodRequest & OpenPeriodSuccess & OpenPeriodFailure & OpenPeriodAction;

function* openPeriod(action: IActions) {

    try {

        yield put({type: OPEN_PERIOD_ACTION_REQUEST});

        const dataPeriod = yield call(Api.fetch, {
            endpoint: 'periods/open',
            method: ApiMethods.POST
        });

        const {responseData} = dataPeriod;

        if (responseData.errorReason) {
            action.onOpenPeriodFailure(responseData.message);
        } else {
            yield put({
                type: OPEN_PERIOD_ACTION_SUCCESS,
                current: responseData
            });
        }

    } catch (e) {
        yield put({type: OPEN_PERIOD_ACTION_FAILURE, error: e});
    }
}

function* openPeriodSaga() {
    yield takeEvery(OPEN_PERIOD_ACTION, openPeriod);
}

export {
    openPeriodSaga
};
